module.exports = __webpack_public_path__ + "assets/802864ecfabd58924561287ab57f4f0f.png";